var _clipPath, _path, _path2, _path3, _path4, _path5, _path6, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 600,
    width: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v150h700v150H600zm0 300v50h300V0h300z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1200v600H0z",
    fill: "#012169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l600 300m0-300L0 300",
    stroke: "#fff",
    strokeWidth: 60
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#a)",
    d: "M0 0l600 300m0-300L0 300",
    stroke: "#c8102e",
    strokeWidth: 40
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 150h700M300 0v350",
    stroke: "#fff",
    strokeWidth: 100
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 150h700M300 0v350",
    stroke: "#c8102e",
    strokeWidth: 60
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 300h600V0h600v600H0z",
    fill: "#0095c8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fedd00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M645.34 490.913l29.436 90.597-77.066-55.992h95.26l-77.067 55.993zM817.462 464l-29.436 90.597L758.589 464l77.066 55.992h-95.26zM817.462 342.016l-29.436 90.597-29.437-90.597 77.066 55.992-95.26.001zM943.467 433.168l-29.437 90.597-29.436-90.597 77.066 55.992-95.26.001zM943.467 167.755l-29.437 90.597-29.436-90.597 77.066 55.992H866.4zM996.442 339.965l29.436 90.597-77.066-55.992h95.26l-77.067 55.993zM1049.365 131.561l-29.437 90.597-29.437-90.597 77.067 55.992-95.26.001zM1102.836 271.474l29.437 90.597-77.067-55.992h95.26l-77.067 55.993zM1102.836 37.405l29.437 90.597-77.067-55.992h95.26l-77.067 55.993z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.96affc11e419b9d3db4b58fd69f6734b.svg";
export { ForwardRef as ReactComponent };